import VoucherValidator from './payment/VoucherValidator'
import PageStateManager from './payment/PageStateManager'
import LinkGenerator from './payment/LinkGenerator'

export default class PaymentPage {
  constructor() {
    let urlParams = new URLSearchParams(window.location.search)
    this.voucherValidator = new VoucherValidator(urlParams)
    this.pageStateManager = new PageStateManager(this)
    this.linkGenerator = new LinkGenerator(this)
  }

  async mount() {
    if (this.voucherValidator.isPresent()) {
      if (await this.voucherValidator.isValid()) {
        this.linkGenerator.mountPaymentLinks()
        this.pageStateManager.showPaymentForm()
      } else {
        this.pageStateManager.showVoucherErrorBox()
      }
    } else {
      this.pageStateManager.showNoVoucherBox()
    }
    return this
  }
}
